import {
  keepPreviousData,
  useInfiniteQuery,
  useQuery,
} from "@tanstack/react-query";
//import axios from 'axios';
import axios from "@/utils/axios";
import { createApiResponseSchema } from "@/types/common/pagination";
import { z } from "zod";

type DashboardData = {
  data: {
    metrics: {
      processes_qty: number;
      flows_qty: number;
      formality_requests_qty: number;
    };
    formality_requests: {
      in_process_qty: number;
      done_qty: number;
      pending_qty: number;
    };
  };
};

const fetchDashboardData = async (): Promise<DashboardData> => {
  const response = await axios.get(`/admin/v1/dashboard`);
  return response.data;
};

export const useGetDashboardData = () => {
  return useQuery({
    queryKey: ["dashboard-data"],
    queryFn: fetchDashboardData,
    refetchInterval: 300000, // 5 minutes in milliseconds
  });
};

// Separate hook for metrics section
export const useGetDashboardMetrics = () => {
  return useQuery({
    queryKey: ["dashboard-metrics"],
    queryFn: fetchDashboardData,
    refetchInterval: 300000, // 5 minutes in milliseconds
  });
};

// Separate hook for formality requests section
export const useGetDashboardFormalityRequests = () => {
  return useQuery({
    queryKey: ["dashboard-formality-requests"],
    queryFn: fetchDashboardData,
    refetchInterval: 300000, // 5 minutes in milliseconds
  });
};

// TODO: Move to its own file

const logsSchema = z.object({
  id: z.number(),
  causer: z.object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.email(),
    dui: z.number().optional(),
    id: z.string(),
  }),
  description: z.string(),
  created_at: z.iso.datetime(),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const response = createApiResponseSchema(logsSchema);
type LogsResponse = z.infer<typeof response>;

export const useGetDashboardLogs = (enabled: boolean) => {
  return useInfiniteQuery({
    queryKey: ["dashboard-logs"],
    queryFn: async ({ pageParam = 1 }): Promise<LogsResponse> => {
      const response = await axios.get("/admin/v1/log", {
        params: {
          page: pageParam,
          per_page: 10,
        },
      });
      //return response.data;
      return {
        ...response.data,
        data: [],
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = (lastPage as LogsResponse).meta;
      if (current_page < last_page) {
        return current_page + 1;
      }
    },
    enabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
